import { render } from "./InspectorTabs.vue?vue&type=template&id=da5a6af0"
import script from "./InspectorTabs.vue?vue&type=script&lang=js"
export * from "./InspectorTabs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__